<template lang="html">

    <div class="slide-container -gallery">
        <slick ref="slick" :options="slickOptions">
            <div class="slide" v-for="(data,key) in gallery">
                <div class="image-box" @click="show(key)" :style="`background:url(${data.url}) center/cover no-repeat`"></div>
            </div>
        </slick>

        <div class="popup-gallery" v-show="showpopup">

            <a class="close" @click="showpopup = false">✕</a>

            <div class="contenedor-popup">
                <slick ref="slickpopup" :options="slickOptionsPopup">
                    <div class="slide" v-for="(data,key) in gallery">
                        <div class="imagen-container">
                            <img :src="data.url" alt="imagen-container">
                        </div>
                    </div>
                </slick>
            </div>
        </div>

    </div>

</template>

<script lang="js">


    import { mapGetters } from 'vuex'

    import Slick from 'vue-slick';

    export default {
        name: 'slide',
        props: ['gallery'],
        data() {
            return {
                slickOptions: {
                    slidesToShow: 4,
                    centerMode : false
                },
                slickOptionsPopup: {
                    slidesToShow: 1,
                    arrows : true
                },
                showpopup : false
            }
        },
        methods : {
            show(pos){
                this.showpopup = true;
                setTimeout(() => {
                    this.$refs.slickpopup.goTo(pos);
                },200)
            }
        },
        components: {
            Slick
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/parts/slide.vue